import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArrowLeft, Droplets, Sun, Ban, ShowerHead } from "lucide-react";

const STEPS = [
  { icon: Droplets, title: "Tag 1–3", body: "Folie wie besprochen tragen. Danach zwei bis drei Mal täglich mit sauberen Händen dünn eincremen." },
  { icon: ShowerHead, title: "Waschen", body: "Kurz mit lauwarmem Wasser und milder, parfümfreier Seife abwaschen, danach lufttrocknen lassen." },
  { icon: Ban, title: "Vermeiden", body: "Zwei bis drei Wochen kein Bad, keine Sauna, kein Schwimmbad, kein Kratzen und keine engen Kleidungsstücke." },
  { icon: Sun, title: "Sonne", body: "Frisches Tattoo nicht in die direkte Sonne. Später konsequent mit hohem Lichtschutzfaktor schützen." },
];

export default function Pflege() {
  return (
    <>
      <Seo
        title="Pflegeanleitung – ArtPart"
        description="Kurze mobile Pflegeanleitung für dein frisches Tattoo von ArtPart."
        path="/pflege"
      />
      <main className="min-h-screen bg-paper">
        <div className="ap-container max-w-2xl py-14 sm:py-20">
          <p className="ap-stamp">ARTPART · PFLEGE</p>
          <h1 className="ap-h1 mt-4 text-ink">Pflegeanleitung</h1>
          <p className="ap-lead mt-5">
            Ein Tattoo heilt am besten in Ruhe. Diese Punkte gelten für die ersten Wochen – bei Fragen oder
            Unsicherheiten melde dich direkt bei René.
          </p>

          <ol className="mt-10 space-y-4">
            {STEPS.map(({ icon: Icon, title, body }, i) => (
              <li key={title} data-testid={`care-step-${i}`} className="flex gap-4 border border-paper-line bg-paper-surface p-5">
                <Icon size={20} className="mt-1 shrink-0 text-signal" />
                <div>
                  <h2 className="font-display text-lg font-bold uppercase tracking-wide text-ink">{title}</h2>
                  <p className="ap-body mt-1 text-charcoal">{body}</p>
                </div>
              </li>
            ))}
          </ol>

          <p className="ap-body mt-8 border-l-2 border-signal pl-4 text-charcoal">
            Diese Anleitung ersetzt keine medizinische Beratung. Bei Rötungen, Fieber oder starkem Schmerz wende dich
            an eine Ärztin oder einen Arzt.
          </p>

          <Link to="/" className="ap-btn-ghost mt-10" data-testid="care-back">
            <ArrowLeft size={15} /> Zur ArtPart-Seite
          </Link>
        </div>
      </main>
    </>
  );
}
